import { HttpInterceptorFn } from '@angular/common/http';
import { authTokenStorageKey } from '../app.constants';

/**
 * Adds the JWT token stored in local storage to API requests.
 */
export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(authTokenStorageKey);
  // /api/password doesn't require a token
  if (!req.url.includes('api') || !token) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
